@if (!hideHeader) {
  <app-bread-crumbs [(breadcrumbs)]="breadcrumbs"></app-bread-crumbs>
}
<div class="container pb-5">
  <div class="row">
    <div class="col-md-12" [ngClass]="!hideHeader ? 'px-3' : 'px-0'">
      @if (!hideHeader) {
        <h1><app-header-icon iconName="shopping_basket"></app-header-icon>{{ "BASKETS" | translate }}</h1>
      }
      @if (!hideHeader) {
        <app-select-basket-type
          [type]="type"
          (tabChanged)="tabChanged($event)"
        ></app-select-basket-type>
      }
      @if (baskets && baskets.length) {
        <ul class="ps-0 list-group list-group-flush bg-transparent" [@pageAnimations]>
          @for (basket of baskets; track basket) {
            <li class="px-0 list-group-item px-md-2 basket-item mb-2 rounded">
              <app-basket-item
                [basket]="basket"
                (basketDeleted)="basketDeleted($event)"
                [preorder]="basket.pre_order"
                [style.order]="basket.pre_order ? '1' : 'initial'"
                [deleted]="type === 'archive'"
                [basePage]="basePage"
              ></app-basket-item>
            </li>
          }
        </ul>
      }
      @if (loaded && baskets && !baskets.length) {
        <ngb-alert
          class="mt-2"
          [type]="'warning'"
          [dismissible]="false"
          >
          {{ "NO_RESULTS" | translate }}
        </ngb-alert>
      }
    </div>
  </div>
</div>
